import React from 'react';
import { View, SafeAreaView, StyleSheet, ActivityIndicator,TouchableOpacity } from 'react-native';
import TestAttempt from './quiz';
// import Timer from '../Timer';
import { markedQuestions } from '../../store/action';
import { connect } from 'react-redux';
// import { Checkbox } from 'react-native-paper';
import { Text, Styles } from "./../../components/UI-Components"
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
class Quiz extends React.Component {
  

    state = {
        checked: false
    }


    isMarked() {
        const { testInfo, questionsInfo, activeQustion } = this.props;
        const id = testInfo.test[activeQustion].id;
        let isChecked = false;
        questionsInfo.map(qi => {
            if (qi.id === id) {
                qi.marked ? (isChecked = true) : (isChecked = false)
            }
        })
        return isChecked ? true : false;
    }


    render() {
        const { checked } = this.state;
        // console.log(this.isMarked())
        const { testInfo, loading, totalQuestion, activeQustion, markedQuestions, questionsInfo } = this.props;
        // console.log(this.props, 'quiz', testInfo, testInfo.testInfo);
        return (
                <View style={{flex:1}}>
                    <View style={styles.flexRowBetween}>
                        <View style={{marginLeft:15}}>
                            <Text style={styles.flexRow}>
                                <Text style={{fontWeight:'700',color:'#222',fontSize:12}}>{activeQustion + 1}</Text> of <Text style={{fontWeight:'700',color:'#222',fontSize:12}}>{totalQuestion}</Text> Questions
                                </Text>
                        </View>
                        
                           <TouchableOpacity 
                           onPress={() => {
                            const id = testInfo.test[activeQustion].id; 
                            markedQuestions(id);
                        }}
                           >
                           <View style={[styles.flexRow, { justifyContent: 'flex-end',marginRight:10 }]}>
                           
                                <Text style={{paddingRight:2,fontWeight:'400',fontSize:12}}>Mark Question</Text>
                                {/* <Checkbox
                                    status={this.isMarked()}
                                    fontSize={12}
                                    style={{ marginRight:8,fontSize:12 }}
                                /> */}
                                     <FormControlLabel
                                    control={
                                        <Checkbox
                                        checked={this.isMarked()}
                                        // onChange={this.handleChange}
                                        name="checked"
                                        color="primary"
                                   />
                              }
                              
                            />
                                <Text style={{paddingRight:2,fontWeight:'400',fontSize:14, color: Styles.primaryColor, marginLeft: 12, fontWeight: '500'}}>Save Question</Text>

                                 </View>
                           </TouchableOpacity>
                       
                    </View>

                    <TestAttempt data={testInfo.test} />
                </View>
        )
    }
}


const mapStateToProps = state => ({
    testInfo: state.testInfo,
    loading: state.testInfo && state.testInfo.loading,
    totalQuestion: state.testInfo && state.testInfo.test && state.testInfo.test.length,
    activeQustion: state.testInfo && state.testInfo.activeQuestion,
    questionsInfo: state.testInfo && state.testInfo.questionsInfo && state.testInfo.questionsInfo || []
})

const styles = StyleSheet.create({
    flexRow: {
        // flex:1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize:12
    },
    flexRowBetween: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottomWidth:1,
        borderBottomColor:'#ccc',
    }
})

export default connect(mapStateToProps, { markedQuestions })(Quiz);

